import React from 'react';
import HeaderComponent from '../commons/header';
import Footer2Component from '../commons/footer2';
import Splash_Term from '../commons/splash_term';
import Splash_Signin from '../commons/splash_signin';

import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

export default class TermPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div id="splash" className={isMobile?"mobile-page page_other":"page_other pd0"}>
                <header>
                    <div className="header">
                        <div className="splash_logo">
                            {isMobile ?
                                <Link to="/"><img alt="VERSITY" src="/static/img/appimg/login_h_logo.png"/></Link>
                                :
                                <Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link>
                            }
                        </div>
                    </div>
                </header>
                <div className={"block-002"}>
                    <Splash_Term/>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/terms.js
 **/